export default "__VITE_ASSET__BSs0XhA9__"